export default [
  {
    path: '/notes/add',
    component: () => import('@/views/Notes/AddNote.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/notes/:noteId',
    component: () => import('@/views/Notes/NoteDetail.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus-detail',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/notes/:noteId/edit',
    component: () => import('@/views/Notes/EditNote.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/notes/:noteId/tags',
    component: () => import('@/views/Bookmarks/EditTags.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
  {
    path: '/notes/:id/add-collections',
    component: () => import('@/views/CollectionItems/AddToCollections.vue'),
    meta: {
      requiresAuth: true,
      layout: 'focus',
      transition: 't-fade',
      layoutTransition: 't-fade',
      systemBar: {
        color: 'neutral0',
      },
    },
  },
]
